import React from "react"
import { Link } from "gatsby"
import logo from "./images/logo-light.png"

const Logo = props => {
  const link_class = props.logoAlign + " auth-brand"
  return (
    <Link to={"/"} className={link_class} style={props.style}>
      <img alt="..." src={logo} />
    </Link>
  )
}

export default Logo
